export const titles = {
  1: 'Spielanleitung',
  2: 'Jüdische Gemeinden',
  3: 'Migration',
  4: 'Vereinswesen',
  5: 'Synagoge',
  6: 'Der Rabbiner',
  7: 'Jüdischer Friedhof',
  8: 'Zionistenkongresse',
  9: 'Menschen',
  10: 'Zentren um 1910',
  11: 'Rundgang',
  12: 'Ausblick',
};
